import { useEffect, useState } from 'react';
import useMediaQuery from './useMediaQuery';
type BrowserCompat = {
  isClientDevice: boolean;
  isSafari: boolean | undefined;
  isMobileRequested: boolean | undefined;
  isTouchDevice: boolean | undefined;
  isHoverDevice: boolean | undefined;
};

const calcIsSafari = (): boolean | undefined => {
  if (typeof navigator === 'undefined' || !navigator?.userAgent) {
    return undefined;
  }

  // Note: Includes other iOS browsers, since they all use Safari's rendering engine.
  return (
    !!navigator.userAgent.match(/Safari/i) &&
    !navigator.userAgent.match(/Chrome|Android|YaBrowser/i)
  ); /* |CriOS|FxiOS|EdgiOS|OPiOS */
};

const calcIsMobileRequested = (): boolean | undefined => {
  if (typeof navigator === 'undefined' || !navigator?.userAgent) {
    return undefined;
  }

  return /Mobile/.test(navigator.userAgent);
};

export default function useBrowserCompat(): BrowserCompat | undefined {
  const [isClientDevice, setIsClientDevice] = useState(false);
  const isTouchDevice = useMediaQuery('(pointer: coarse)');
  const isHoverDevice = useMediaQuery('(any-hover)');

  const isMobileRequested = calcIsMobileRequested();
  const isSafari = calcIsSafari();

  useEffect(() => {
    setIsClientDevice(typeof window !== 'undefined');
  }, []);

  return { isClientDevice, isSafari, isMobileRequested, isTouchDevice, isHoverDevice };
}
